'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var StyledLabelBlock = styled__default.span(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  width: 162px;\n  height: 80px;\n  border-radius: 4px;\n  background-color: ", ";\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-end;\n  box-shadow: ", ";\n  cursor: pointer;\n  box-sizing: border-box;\n  padding: 0 0 4px 12px;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-image: ", "};\n"], ["\n  width: 162px;\n  height: 80px;\n  border-radius: 4px;\n  background-color: ", ";\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-end;\n  box-shadow: ", ";\n  cursor: pointer;\n  box-sizing: border-box;\n  padding: 0 0 4px 12px;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-image: ", "};\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.universal.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.shadows.depth_2;
}, function (_a) {
    var backgroundImageUrl = _a.backgroundImageUrl;
    return (backgroundImageUrl ? "url(" + backgroundImageUrl + ")" : 'none');
});
var LabelBlockText = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  font-family: ", ";\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 24px;\n  color: ", "\n"], ["\n  font-family: ", ";\n  font-weight: normal;\n  font-size: 16px;\n  line-height: 24px;\n  color: ", "\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.darkGrey7;
});
var GhostLabelBlock = styled__default.div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  width: 162px;\n  height: 80px;\n  border-radius: 4px;\n  box-sizing: border-box;\n  background-color: ", ";\n"], ["\n  width: 162px;\n  height: 80px;\n  border-radius: 4px;\n  box-sizing: border-box;\n  background-color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyLight;
});
var Container = styled__default.div(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  width: 162px;\n  height: 80px;\n"], ["\n  width: 162px;\n  height: 80px;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

exports.Container = Container;
exports.GhostLabelBlock = GhostLabelBlock;
exports.LabelBlockText = LabelBlockText;
exports.StyledLabelBlock = StyledLabelBlock;
